import type { ComponentType, MouseEventHandler } from 'react'
import type { Reporter } from '../reporting'
import type { createHostProps } from '../hostProps'
import styles from './tpaWidgetNativeClient.scss'

export type Props = {
	id: string
	ReactComponent?: ComponentType<any>
	host: ReturnType<typeof createHostProps> & {
		registerToComponentDidLayout: (cb: Function) => void
		unregisterFromComponentDidLayout: () => void
	}
	sentryDsn?: string
	reporter: Reporter
	onMouseLeave: MouseEventHandler
	onMouseEnter: MouseEventHandler
	fitToContentHeight?: boolean
	heightOverflow?: boolean
	shouldWrapWithSuspense: boolean
	shouldAddIdAsClassName: boolean
	shouldModifyComponentId: boolean
	__VIEWER_INTERNAL?: { failedInSsr: boolean }
}

export const getSharedProps = (props: Props, shouldAddIdAsClassName?: boolean) => {
	return {
		id: props.id,
		className: [
			props.fitToContentHeight ? styles.fitToContentHeight : '',
			props.heightOverflow ? styles.heightOverflow : '',
			shouldAddIdAsClassName ? props.id : '',
		].join(' '),
	}
}

export const getPropsForReactComponent = (props: Props, shouldModifyComponentId?: boolean) => {
	if (!shouldModifyComponentId) {
		return props
	}
	const ooiId = props.id + '_ooi'
	return { ...props, id: ooiId, host: { ...props.host, id: ooiId } }
}
